import { ActionNames } from '../action-names';
import { IAppState } from '../models';

export type UpdateOgType = { type: ActionNames.UPDATE_OG_TYPE; value: string };

export function ogActionHandlers(currentState: IAppState, action: UpdateOgType): IAppState {

    switch (action.type) {
        case ActionNames.UPDATE_OG_TYPE: {
            return {
                ...currentState,
                metadata:
                {
                    ...currentState.metadata,
                    ogType: action.value
                }
            };
        }
        default:
            return currentState;
    }
}
